'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import HelpQuestion from 'ck-core-client/source/ui/HelpQuestion';

export default class Help extends React.Component {
	render() {
		return (
			<div className="Help">
				<div className="header">{this.props.title}</div>
				{this.props.questions.map((question, index) => <HelpQuestion key={index} {...question} />)}
			</div>
		);
	}
}

Help.propTypes = {
	title: PropTypes.string.isRequired,
	questions: PropTypes.arrayOf(
		PropTypes.shape({
			question: PropTypes.string.isRequired,
			answer: PropTypes.node.isRequired
		})
	)
};
